import type { MfdsDeclarationListItem } from '@/types/api';

const DATA_SHEET_NAME = '알코올 데이터';
const EXCEL_MIME_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
const DATA_START_ROW = 3;

function normalizeName(value: string | null) {
  return value?.trim() ?? '';
}

function getUniqueDraftRows(items: MfdsDeclarationListItem[]) {
  const uniqueRows = new Map<
    string,
    { korName: string; engName: string; abvPercent: number | null; volumeMl: number | null }
  >();

  items.forEach((item) => {
    const korName = normalizeName(item.skuDisplayNameKo) || normalizeName(item.baseProductNameKo);
    const engName = normalizeName(item.skuDisplayNameEn) || normalizeName(item.baseProductNameEn);
    if (!korName && !engName) return;

    const abvPercent = item.abvPercent ?? null;
    const volumeMl = item.volumeMl ?? null;
    const key = JSON.stringify([korName, engName, abvPercent, volumeMl]);
    if (!uniqueRows.has(key)) {
      uniqueRows.set(key, { korName, engName, abvPercent, volumeMl });
    }
  });

  return [...uniqueRows.values()];
}

export function getAlcoholRegistrationDraftRowCount(items: MfdsDeclarationListItem[]) {
  return getUniqueDraftRows(items).length;
}

export async function createAlcoholRegistrationDraft(
  template: ArrayBuffer,
  items: MfdsDeclarationListItem[]
) {
  const { default: ExcelJS } = await import('exceljs');
  const workbook = new ExcelJS.Workbook();
  await workbook.xlsx.load(template);

  const dataSheet = workbook.getWorksheet(DATA_SHEET_NAME);
  if (!dataSheet) throw new Error('알코올 데이터 시트를 찾을 수 없습니다.');

  const draftRows = getUniqueDraftRows(items);
  draftRows.forEach(({ korName, engName, abvPercent, volumeMl }, index) => {
    const row = dataSheet.getRow(DATA_START_ROW + index);
    row.getCell(1).value = korName;
    row.getCell(2).value = engName;
    if (abvPercent !== null) row.getCell(3).value = abvPercent;
    if (volumeMl !== null) row.getCell(12).value = volumeMl;
  });

  const buffer = await workbook.xlsx.writeBuffer();
  return {
    blob: new Blob([buffer], { type: EXCEL_MIME_TYPE }),
    declarationCount: draftRows.length,
  };
}
